import { SET_TEMPLATE_FILES, CLEAR_TEMPLATE_FILES } from './whatsappTemplateFileTypes';

export const setTemplateFiles = (templateFiles) => ({
    type: SET_TEMPLATE_FILES,
    payload: templateFiles
});

export const clearTemplateFiles = () => ({
    type: CLEAR_TEMPLATE_FILES,
});
